const initShare = (handler) => {
    document.addEventListener("click", (event) => {
        const button = event.target.closest(".js-share");

        if (!button) return;

        event.preventDefault();
        handler(button.dataset);
    });
};

const fallbackShare = (data) => {
    const url = data.link || window.location.href;
    const text = data.text || document.title;
    const shareText = `${text} ${url}`.trim();

    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(shareText).catch(() => {
            window.prompt("Copy this link:", url);
        });
        return;
    }

    window.prompt("Copy this link:", url);
};

const getSharePayload = (data) => ({
    url: data.link || window.location.href,
    text: data.text || document.title,
});

// Riesenia wrapper app — native share sheet through the bridge (common/app/app-bridge.js).
// Outside the app AppBridge.isApp is false, so this branch never triggers on the web.
const shareWithAppBridge = (data) => {
    const bridge = window.AppBridge;

    if (!bridge || !bridge.isApp) {
        return false;
    }

    const payload = getSharePayload(data);

    bridge.callBridge("SHARE", { url: payload.url, text: payload.text }).catch(() => {
        fallbackShare(data);
    });

    return true;
};

const shareWithGoNative = (data) => {
    if (typeof gonative === "undefined" || !gonative.share) {
        return false;
    }

    const payload = getSharePayload(data);

    if (typeof gonative.share.sharePage === "function") {
        gonative.share.sharePage(payload);
        return true;
    }

    if (typeof gonative.share.share === "function") {
        gonative.share.share(payload);
        return true;
    }

    if (typeof gonative.share.shareText === "function") {
        gonative.share.shareText(payload.text);
        return true;
    }

    return false;
};

const shareWithFlutter = (data) => {
    const payload = getSharePayload(data);

    if (window.FlutterApp) {
        if (typeof window.FlutterApp.sharePage === "function") {
            window.FlutterApp.sharePage(payload.url, payload.text);
            return true;
        }

        if (typeof window.FlutterApp.share === "function") {
            window.FlutterApp.share(payload.url, payload.text);
            return true;
        }
    }

    if (
        window.flutter_inappwebview &&
        typeof window.flutter_inappwebview.callHandler === "function"
    ) {
        let settled = false;
        const fallbackTimer = window.setTimeout(() => {
            if (!settled) {
                fallbackShare(data);
            }
        }, 800);

        window.flutter_inappwebview
            .callHandler("share", payload.url, payload.text)
            .then(() => {
                settled = true;
                window.clearTimeout(fallbackTimer);
            })
            .catch(() => {
                settled = true;
                window.clearTimeout(fallbackTimer);
                fallbackShare(data);
            });

        return true;
    }

    if (window.FlutterApp && typeof window.FlutterApp.postMessage === "function") {
        window.FlutterApp.postMessage(
            JSON.stringify({
                action: "share",
                url: payload.url,
                text: payload.text,
            })
        );
    }

    return false;
};

const shareWithWebShare = (data) => {
    if (!navigator.share) {
        return false;
    }

    navigator
        .share({
            title: data.text,
            url: data.link,
        })
        .catch(console.error);

    return true;
};

initShare((data) => {
    if (shareWithAppBridge(data)) {
        return;
    }

    if (shareWithGoNative(data)) {
        return;
    }

    if (shareWithFlutter(data)) {
        return;
    }

    if (shareWithWebShare(data)) {
        return;
    }

    fallbackShare(data);
});

const copyToClipboard = (text) => {
    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
    }

    return new Promise((resolve, reject) => {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();

        let copied = false;

        try {
            copied = document.execCommand("copy");
        } catch (e) {
            copied = false;
        }

        document.body.removeChild(textarea);
        copied ? resolve() : reject(new Error("copy failed"));
    });
};

document.addEventListener("click", (event) => {
    const button = event.target.closest(".js-copy-link");

    if (!button) return;

    event.preventDefault();

    const url = button.dataset.link || window.location.href;

    copyToClipboard(url)
        .then(() => {
            Eshop.alert(button.dataset.message || "Odkaz bol skopírovaný", { type: "success" });
        })
        .catch(() => {
            window.prompt("Copy this link:", url);
        });
});
